import { IModel } from '../model/listResponse';
import IProductImage from '../../../../common/model/IProductImage';
import IProductVariantDetails from '../model/IProductVariantDetails';
import IStockModel from '../../stock/model/IStockModel';
import { ImageType } from '../../../../common/enum/ImageType';

const modelDataAccessor = {
  getProductImage(model: IModel | IProductVariantDetails | IStockModel): IProductImage | null {
    const image = model.images.find(image => ImageType.MAIN === image.type);

    if (!image) {
      return null;
    }

    return image;
  },

  getExteriorImage(model: IModel | IProductVariantDetails | IStockModel): IProductImage | null {
    let images: IProductImage[] = [];
    if ('exteriorColour' in model) {
      images = model?.exteriorColour?.images ?? [];
    }
    const image = images.find((image: any) => ImageType.FRONT === image.type);

    if (!image) {
      return null;
    }

    return image;
  },
};

export default modelDataAccessor;
